import { useEffect, useState } from 'react';
import pricingService, { FALLBACK_PRICING } from '../services/pricingService';

/**
 * Barème de tarification servi par le backend (tarifs transport, taux de frais).
 * Aucun taux n'est écrit en dur dans les écrans : un montant annoncé au client
 * vient toujours de l'API.
 */
export const usePricing = () => {
  const [pricing, setPricing] = useState(FALLBACK_PRICING);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    pricingService
      .getPricing()
      .then((next) => {
        if (!cancelled) setPricing(next);
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { pricing, loaded };
};

export default usePricing;
